import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { EffectifDto } from "../../../../dto/GenApi.iNotPaie.Dto/EffectifDto";

@Component
export default class ModalCardWorkforce extends Vue {
	@Prop()
	public effectif: EffectifDto = {
    	NbrCadres: 0,
    	NbrCDD: 0,
    	NbrEmployes: 0,
    	NbrTechniciens: 0,
    	EffectifsParCategorie: [],
    	EntreesSorties: []
	};

	public listeEchelle: number[] = [];
	public hauteurUnitaire = 30;
	public largeurItem = 100;
	public unite = 0;
	public tooltip1 = "<div class=\"d-flex\"><div class=\"col-6\" style=\"color:#F6678D\">Temps plein</br><h4><strong>";
	public tooltip2 = "</strong></h4></div><div class=\"col-6\" style=\"color:#FCA253\">Temps partiel</br><h4><strong>";
	public tooltip3 = "</strong></h4></div></div>";

	@Watch("effectif")
	public onPropertyChanged(): void {
    	this.calculateModal();
	}

	public calculateModal(): void {
    	if (this.effectif == undefined || this.effectif.EffectifsParCategorie == undefined) {
			return;
		}

    	this.largeurItem = 580 / this.effectif.EffectifsParCategorie.length;
    	let maxValue = 0;
    	for (let i = 0; i < this.effectif.EffectifsParCategorie.length; i++) {
    		if (this.effectif.EffectifsParCategorie[i].NbrTempsPartiel > maxValue) {
    			maxValue = this.effectif.EffectifsParCategorie[i].NbrTempsPartiel;
    		}
    		if (this.effectif.EffectifsParCategorie[i].NbrTempsPlein > maxValue) {
    			maxValue = this.effectif.EffectifsParCategorie[i].NbrTempsPlein;
    		}
    	}
    	this.unite = Math.ceil(maxValue / 5);
    	const listeUnite: number[] = [];

    	for (let i = 0; i < 5; i++) {
    		listeUnite.push(this.unite * (5 - i));
    	}
    	this.listeEchelle = listeUnite;
    	this.hauteurUnitaire = 60 / this.unite;
	}

	public getSizeEchelle(): any {
    	const hauteurEchelle = this.hauteurUnitaire * this.unite;

    	return {
    		height: hauteurEchelle + "px"
    	};
	}

	public getSize(hauteur: number, index: number): any {
    	const hauteurBase = hauteur * this.hauteurUnitaire;
    	const indexBase = index * this.largeurItem + 15;

    	return {
    		height: hauteurBase + "px",
    		left: indexBase + "px"
    	};
	}

	public getLibellePosition(index: number): any {
    	const indexBase = index * this.largeurItem;

    	return {
    		left: indexBase + "px"
    	};
	}

	public getSizeTempsPartiel(hauteur: number, index: number): any {
    	const hauteurBase = hauteur * this.hauteurUnitaire;
    	const indexBase = index * this.largeurItem + 35;

    	return {
    		height: hauteurBase + "px",
    		left: indexBase + "px"
    	};
	}
}




// WEBPACK FOOTER //
// ./src/components/home/modals/modalCardWorkforce/modalCardWorkforce.ts